import { useDispatch } from 'react-redux'
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap'
import { DEAL_HEALTH_ERROR } from 'components/Deal/actions'
import s from './HealthWarningModal.scss'

const HealthWarningModal = ({ toggleHealthWarningModal, showHealthWarningModal }) => {
  const reduxDispatch = useDispatch()

  const closeWarningModal = () => {
    reduxDispatch({
      type: DEAL_HEALTH_ERROR,
      payload: {
        healthError: false
      }
    })
    toggleHealthWarningModal()
  }

  return (
    <Modal
      keyboard={false}
      backdrop="static"
      isOpen={showHealthWarningModal}
      toggle={toggleHealthWarningModal}
      size="md"
    >
      <ModalHeader toggle={toggleHealthWarningModal} className={s.modalHeader}>
        Error saving opportunity health
      </ModalHeader>
      <ModalBody>
        <div className={s.main}>
          <p>
            This opportunity has either an overdue bid due date or follow-date date or a task that
            has not been completed on time.
          </p>
          <p>
            You need to change either of dates above and complete tasks before you can manually
            update the opportunity heath field.
          </p>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button className={s.saveBtn} onClick={closeWarningModal}>
          OK
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default HealthWarningModal
